<template>
  <AddEditTemplate
    v-if="formData && !loading"
    :isEditMode="isEditMode"
    addEditType="Checkride"
    :initialData="formData"
    :submitAction="submitForm"
  >
    <template #default="{ formData }">
      <AddEditFormGroup
        label="Student"
        fieldId="studentId"
        v-model="formData.studentId"
        component="select"
        :options="activeStudentOptions"
      />
      <AddEditFormGroup
        label="DPE"
        fieldId="dpeId"
        v-model="formData.dpeId"
        component="select"
        :options="dpeOptions"
      />
      <AddEditFormGroup
        label="Instructor"
        fieldId="instructorId"
        v-model="formData.instructorId"
        component="select"
        :options="activeInstructorOptions"
      />
      <AddEditFormGroup
        label="Aircraft"
        fieldId="aircraftId"
        v-model="formData.aircraftId"
        component="select"
        :options="aircraftOptions"
      />
      <AddEditFormGroup
        label="Start"
        fieldId="startDateTime"
        v-model="formData.startDateTime"
        type="datetime-local"
        clickable
      />
      <AddEditFormGroup
        label="End"
        fieldId="endDateTime"
        v-model="formData.endDateTime"
        type="datetime-local"
        clickable
      />
      <AddEditFormGroup
        label="Result Status"
        fieldId="checkrideResultStatusId"
        v-model="formData.checkrideResultStatusId"
        component="select"
        :options="resultStatusOptions"
      />
    </template>
  </AddEditTemplate>
</template>

<script>
import AircraftAPIService from "../../../../servicehandlers/AircraftAPIService.js";
import ActiveInstructorsAPIService from "../../../../servicehandlers/ActiveInstructorsAPIService.js";
import DpeAPIService from "../../../../servicehandlers/DpeAPIService.js";
import ActiveStudentsAPIService from "../../../../servicehandlers/ActiveStudentsAPIService.js";
import CheckridesAPIService from "../../../../servicehandlers/CheckridesAPIService";
import AddEditTemplate from "./AddEditTemplate.vue";
import AddEditFormGroup from "./AddEditFormGroup.vue";

const aircraftAPIService = new AircraftAPIService();
const activeInstructorsAPIService = new ActiveInstructorsAPIService();
const dpeAPIService = new DpeAPIService();
const activeStudentsAPIService = new ActiveStudentsAPIService();
const checkridesAPIService = new CheckridesAPIService();

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default {
  components: { AddEditFormGroup, AddEditTemplate },
  data() {
    return {
      isEditMode: false,
      loading: true,
      activeStudentOptions: [],
      aircraftOptions: [],
      dpeOptions: [],
      activeInstructorOptions: [],
      selectedEvent: null,
      showReservationModal: false,
      formData: {},
      resultStatusOptions: [],
    };
  },
  async mounted() {
    await this.getActiveStudents();
    await this.getAircraft();
    await this.getInstructors();
    await this.getDpes();
    await this.getResultStatusOptions();
    if (this.$route.params.id) {
      this.isEditMode = true;
      await this.getCheckride(this.$route.params.id);
    }
    this.loading = false;
  },
  methods: {
    async getCheckride(id) {
      try {
        const response = await checkridesAPIService.getById(id);
        this.formData = {
          ...response,
          startDateTime: response.startDateTime
            ? dayjs(response.startDateTime).local().format("YYYY-MM-DDTHH:mm")
            : null,
          endDateTime: response.endDateTime
            ? dayjs(response.endDateTime).local().format("YYYY-MM-DDTHH:mm")
            : null,
        };
        this.selectedEvent = {
          ...this.formData.event,
        };
      } catch (error) {}
    },
    async getActiveStudents() {
      try {
        const response = await activeStudentsAPIService.get();
        this.activeStudentOptions = response.map((student) => ({
          ...student,
          name: `${student.user.firstName} ${student.user.lastName}`,
        }));
      } catch (error) {}
    },
    async getAircraft() {
      try {
        const response = await aircraftAPIService.get(this.$router);
        this.aircraftOptions = response.map((aircraft) => ({
          ...aircraft,
          name: aircraft.tailNumber,
        }));
      } catch (error) {}
    },
    async getInstructors() {
      try {
        const response = await activeInstructorsAPIService.get(this.$router);
        this.activeInstructorOptions = response.map((instructor) => ({
          ...instructor,
          name: `${instructor.user.firstName} ${instructor.user.lastName}`,
        }));
      } catch (error) {}
    },
    async getDpes() {
      try {
        const response = await dpeAPIService.get(this.$router);
        this.dpeOptions = response.map((dpe) => ({
          ...dpe,
          name: `${dpe.user.firstName} ${dpe.user.lastName}`,
        }));
      } catch (error) {}
    },
    async getResultStatusOptions() {
      try {
        this.resultStatusOptions =
          await checkridesAPIService.getResultStatusOptions();
      } catch (error) {}
    },
    async submitForm(formData) {
      try {
        let title = "";
        let startDateTime = "";

        const selectedStudent = this.activeStudentOptions.find(
          (student) => student.id === formData.studentId,
        );

        if (formData.startDateTime) {
          startDateTime = dayjs(formData.startDateTime).utc().format();
          if (selectedStudent) {
            const startTime = dayjs(formData.startDateTime).format("h:mm A");
            title = `${startTime} ${selectedStudent.user.firstName} ${selectedStudent.user.lastName}`;
          }
        }
        const payload = {
          ...formData,
          startDateTime,
          endDateTime: formData.endDateTime
            ? dayjs(formData.endDateTime).utc().format()
            : "",
          title,
        };
        if (this.isEditMode) {
          await checkridesAPIService.update(this.$route.params.id, payload);
        } else {
          await checkridesAPIService.create(payload);
        }
      } catch (error) {}
    },
  },
};
</script>

<style scoped></style>
